import * as React from "react";
import commonStyles from "./Common.module.scss";
import styles from "./Toggle.module.scss";
import { classNames } from "../../Utilities";
import { ReactNode } from "react";
import { InputCommonProps, ValidatedInputProps } from "./Common";
import { useForceUpdate } from "../../Hooks";

interface ToggleProps {
    label?: ReactNode;
}

export const Toggle: React.FC<ToggleProps & ValidatedInputProps & InputCommonProps & React.InputHTMLAttributes<HTMLInputElement>> = (props) => {
    const {
        label,
        validator,
        validations,
        customMessages,
        autoFocus,
        ...inputProps
    } = props;

    const forceUpdate = useForceUpdate();
    const inputRef = React.useRef<HTMLInputElement>(null);

    React.useEffect(() => {
        validator?.register({
            key: props.id,
            validations: validations,
            value: props.checked ? "true" : null,
            forceUpdate: forceUpdate,
            validationMessages: customMessages
        });

        if (autoFocus) inputRef?.current?.focus();

        return () => {
            validator?.unregister(props.id);
        };
    }, []);

    React.useEffect(() => {
        if (validator) {
            validator.setValue(props.id, props.checked ? "true" : null);
            forceUpdate();
        }
    }, [props.checked]);

    const isErrorState = (): boolean => {
        return !!validator && validator.submitAttempted() && validator.getErrors(props.id).length > 0;
    };

    return (
        <div className={classNames([commonStyles.container, styles.container])}>
            <label className={styles.label}>
                <div className={styles.toggle}>
                    <input type="checkbox" {...inputProps} />
                    <span className={classNames([styles.slider, isErrorState() && styles.error])}></span>
                </div>
                {!!label && (
                    <span className={styles.text}>{label}</span>
                )}
            </label>
        </div>
    );
};